import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import { LoadingState, LoadingAction, LoadingActionTypes } from './types'

export const initialState: LoadingState = {
  isLoading: false
}

// @ts-ignore
export const loadingReducer: Reducer<LoadingState> = createReducer<
  LoadingState,
  LoadingAction
>(initialState, {
  [LoadingActionTypes.START_LOADING]: (state: LoadingState) => ({
    ...state,
    isLoading: true
  }),
  [LoadingActionTypes.FINISH_LOADING]: (state: LoadingState) => ({
    ...state,
    isLoading: false
  })
})
